module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/suede_e8e857.jpg";